(function () {
    'use strict';

    angular.module('swif.interventions')
    .controller('RequestConfirmByModalController', RequestConfirmByModalController);

    function RequestConfirmByModalController ($scope, swif, swifOpenbaseSiteService, swifOpenbaseCompanyService) {
        'ngInject';
        console.log('init RequestConfirmByModalController');

        $scope.filters = {
            template: swif.validation.getTemplateFilter()
        };

        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
            $scope.requesterNoteEnable = company.request_note_enable;
        });

        var showOrder = $scope.action.id === 'show_validation';
        $scope.readonly = showOrder;
        var usr = swif.user.getAuthenticatedUserData();
        $scope.survey = swif.validation.initValidationModel();
        $scope.model.survey = $scope.survey;
        $scope.initialize = !showOrder;
        if ($scope.model.validation_order_id && showOrder) {
            $scope.survey = swif.validation.getObjectFromServer($scope.model.validation_order_id[0]);
        }
        $scope._parseValidation = _parseValidation;
        $scope.parseValidationBlocks = parseValidationBlocks;
        $scope.$watch('survey.items', watchItems, true);
        $scope.$watch('survey.template_id', watchTemplateId);

        $scope._siteLoaded = false;
        $scope.loadInterventionSite = function() {
            if (!$scope._siteLoaded && swif.settings.app.modules.openstc_patrimoine && $scope.model.site1) {
                swifOpenbaseSiteService.getSiteAddressById($scope.model.site1[0]).then(site => {
                    swifOpenbaseSiteService.getSiteAddressFields().map(field => {
                        $scope.model[field] = site[field];
                    });
                    $scope._siteLoaded = true;
                });
            }
        };

        var oldNote = $scope.model.survey.note_for_requester
        // Controls the interaction between note field and 'notify the requester' checkbox
        $scope.onNoteChange = function(newNote) {
            // Check the checkbox as soon as 1 character has been typed
            // In order to avoid automatic check when the user progressively remove chars,
            // we need to compare old and new notes
            if(oldNote !== $scope.model.survey.note_for_requester) {
                if(newNote && newNote.length >= 1 && (oldNote ? oldNote.length : 0) < $scope.model.survey.note_for_requester.length) {
                    $scope.model.survey.should_notify_requester = true;
                }
                // Update oldVal
                oldNote = $scope.model.survey.note_for_requester;
            }
            // If the user clear the textarea, uncheck
            if(!newNote) {
                $scope.model.survey.should_notify_requester = false;
            }
        }

        function _parseValidation (items, operator, delimiters, fnct) {
            var ret = '';
            var vals = [];
            if (!delimiters) {
                delimiters = '()';
            }
            _.forEach(items, function (item) {
                vals.push(fnct(item));
            });

            if (items.length > 1) {
                ret = vals.join(' ' + operator + ' ');
                ret = delimiters[0] + ret + delimiters[1];
            } else {
                ret = vals[0] || '';
            }
            return ret;
        }

        function parseValidationBlocks (items) {
            var ret = '';
            ret += $scope._parseValidation(items, 'PUIS', '  ', function (item) {
                return $scope._parseValidation(item.items, 'ET', ['[ ', ' ]'], function (subItem) {
                    return $scope._parseValidation(subItem.items, 'OU', ['( ', ' )'], function (userBlock) {
                        return userBlock.user_id ? userBlock.user_id[1] : '';
                    });
                });
            });
            $scope.validationSumup = ret;
            return ret;
        }
        function watchItems(newV, oldV) {
            if (!angular.equals(newV, oldV) && newV) {
                $scope.parseValidationBlocks(newV);
            }
        }
        function watchTemplateId(newV, oldV) {
            if (!angular.equals(newV, oldV) && newV) {
                $scope.survey = swif.validation.getTemplateFromServer(newV[0], true);
                $scope.survey.creator_id = [usr.id, usr.name];
                $scope.initialize = false;
            }
        }
    }


})();
